import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes';
import "./_scss/tripperbus.scss";
import ReactGA from "react-ga4";
import TagManager from 'react-gtm-module'
import * as Sentry from "@sentry/react";
import posthog from 'posthog-js'
import { loadStopsFromAPI } from './services/stops';

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  environment: process.env.REACT_APP_ENV,
  person_profiles: 'identified_only',
  // Session recording options (matching your original intent)
  session_recording: {
    maskAllInputs: false,
    maskAllText: false,
    maskTextSelector: ".posthog-mask"
  },
  maskInputOptions: {
    password: true,
    credit_card: true
  },
  // Capture pageviews automatically
  capture_pageview: true,
  // Capture page leaves
  capture_pageleave: true,
  // Cross subdomain cookie (useful if you have multiple subdomains)
  cross_subdomain_cookie: true,
  // Loaded callback for error tracking
  loaded: function(posthog) {
    // Track JavaScript errors
    window.addEventListener('error', function(event) {
      posthog.capture('javascript_error', {
        error_message: event.error && event.error.message,
        error_stack: event.error && event.error.stack,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        user_agent: navigator.userAgent,
        url: window.location.href
      });
    });
    
    // Track unhandled promise rejections
    window.addEventListener('unhandledrejection', function(event) {
      posthog.capture('unhandled_promise_rejection', {
        reason: event.reason,
        promise: event.promise,
        url: window.location.href
      });
    });
  }
});


Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllInputs: false,
      maskAllText:false,
      blockAllMedia:false

    }),
  ],
  tracesSampleRate: 1.0, 
  replaysSessionSampleRate: 0.5,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.REACT_APP_ENV,

});

const handleUtmCookie = () => {
  try{
    var rootDomain = process.env.REACT_APP_HOME_DOMAIN_URL;
  rootDomain = rootDomain.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '');
  rootDomain = rootDomain.replace(/:\d+$/, '');
  rootDomain = rootDomain.split('.').slice(-2).join('.');
  const getUtmParamsFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {
      utm: "",
      utm_campaign: ""
    };
    urlParams.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        if (utmParams.utm === "") {
          utmParams.utm = value;
        } else {
          utmParams.utm += `_${value}`;
        }
        if (key === "utm_campaign") {
          utmParams.utm_campaign = value;
        }
      }
    });
    return utmParams;
  };
  const maxage = 30 * 24 * 60 * 60;
  var utm = getUtmParamsFromUrl();
  if(utm.utm !== ""){
    document.cookie = `utm=${JSON.stringify(utm)}; domain=.${rootDomain}; path=/; max-age=${maxage}; SameSite=None; Secure`;
  }
  }catch(e){
  }
};

handleUtmCookie();

// TRIP-158: persist the OpenAI Ads click id (?oppref=... on the landing URL)
// in a root-domain cookie, same lifetime and scope as the utm cookie above.
// Read back at checkout by OrderService.getOaiAttribution() and sent with the
// order body so the server-side Conversions API event can attribute bookings
// whose browser pixel was ad-blocked (the API doesn't capture this itself).
const handleOaiAdsCookie = () => {
  try {
    var rootDomain = process.env.REACT_APP_HOME_DOMAIN_URL;
    rootDomain = rootDomain.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '');
    rootDomain = rootDomain.replace(/:\d+$/, '');
    rootDomain = rootDomain.split('.').slice(-2).join('.');
    const oppref = new URLSearchParams(window.location.search).get('oppref');
    if (oppref) {
      const maxage = 30 * 24 * 60 * 60;
      document.cookie = `oai_oppref=${encodeURIComponent(oppref)}; domain=.${rootDomain}; path=/; max-age=${maxage}; SameSite=None; Secure`;
    }
  } catch (e) {
  }
};
handleOaiAdsCookie();

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID
}
const tagManagerArgs2 = {
  gtmId: process.env.REACT_APP_GTM_ID_2
}
 
ReactGA.initialize(process.env.REACT_APP_MEASUREMENT_ID);
TagManager.initialize(tagManagerArgs)
TagManager.initialize(tagManagerArgs2)


// Load stops from API to replace hardcoded cities, then render
loadStopsFromAPI().finally(() => {
  ReactDOM.render(
    <Routes />,
    document.getElementById('page-top')
  );
});
